import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";


export const assignSurveyApi = createApi({

    reducerPath: 'assignSurveyApi',

    baseQuery: baseQuery,

    endpoints: builder => ({
        getAssignSurvey: builder.query({
            query: ({ page = 1, pageSize = 10, search = '' }) => ({
                url: `/assign.php?q=${search}&pageSize=${pageSize}&page=${page}`,
                method: 'GET'
            })
        }),
        addAssignSurvey: builder.mutation({
            query: (data) => ({
                url: '/assign.php',
                method: 'POST',
                body: data
            })
        }),
        getAssignSurveyById: builder.query({
            query: ({ id }) => ({
                url: `/assign.php?id=${id}`,
                method: 'GET'
            })
        }),

        editAssignSurveyById: builder.mutation({
            query: ({ id, data }) => ({
                url: `/assign.php?id=${id}`,
                method: 'PUT',
                body: data
            })
        }),

        deleteAssignSurveyById: builder.mutation({
            query: ({ id }) => ({
                url: `/assign.php?id=${id}`,
                method: 'DELETE'
            })
        }),
    })
})

export const { useGetAssignSurveyQuery, useGetAssignSurveyByIdQuery, useAddAssignSurveyMutation, useDeleteAssignSurveyByIdMutation, useEditAssignSurveyByIdMutation } = assignSurveyApi;